import { renderFragment, queryFirst, queryAll } from 'lilly/domUtil';
import { scrollSheetTop, activateTab } from '../components/modalApi';

const { initCarouselElement } = require('../components/swiperCarousel').default;
// const { quickView: quickViewTemplates } = require('../templates');
const $body = $('body');
const styliticsPDPWidgetContainer = queryFirst('#stylitics-pdp-api-widget');
const styliticsSettingsContainer = queryFirst('#stylitics-analytics-settings');
const lookSelector = '.js-stylitics-widget-look';
const lookTrigger = '.js-stylitics-look-trigger';
const dialogSelector = '#stylitics-custom-quickview';
const bundleSelector = '.js-stylitics-bundle-container';
const bundleWrapperSelector = '.js-stylitics-bundle-wrapper';
const swatchSelector = '.js-tile-swatch';
const MIN_VISIBLE = 0.75;
const dispatchEventsToSent = [];

/**
 * Scrolls the given sheet element to the top.
 */
function initOutfitImpressions() {
    // Get all bundle cards inside visible Swiper slides
    const getAllOutfitCards = () => {
        return queryAll(bundleWrapperSelector, styliticsPDPWidgetContainer);
    };
    const styliticsWidgetWrapper = queryFirst('.js-carousel-wrapper', styliticsPDPWidgetContainer);

    // IntersectionObserver: count impression only when card is actually visible in widget
    const styliticsWidgetIO = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting || entry.intersectionRatio < MIN_VISIBLE) return;

                const el = entry.target;
                const { styliticsBundleId, styliticsBundleIndex, requestedProductId } = el.dataset;
                if (!styliticsBundleId || !requestedProductId) {
                    styliticsWidgetIO.unobserve(el);
                    return;
                }

                // Bubble event to body for global listener
                const newEvent = new CustomEvent('stylitics:completeLook:trackViewOutfit',
                    {
                        detail: {
                            outfitId: styliticsBundleId,
                            pid: requestedProductId,
                            index: styliticsBundleIndex || 0,
                            uiComponent: 'widget'
                        },
                        bubbles: true
                    }
                );
                const { isStyliticsScriptLoaded } = styliticsSettingsContainer?.dataset || {};
                // If the Stylitics script is already loaded, dispatch the event immediately
                if (isStyliticsScriptLoaded === 'true') {
                    styliticsPDPWidgetContainer.dispatchEvent(newEvent);
                } else if (styliticsSettingsContainer) {
                    // Stylitics script is not yet loaded, queue the event to be sent later
                    window.console.log('Stylitics: PDP widget loaded - Stylitics script not yet loaded, queuing event');
                    dispatchEventsToSent.push(newEvent);
                }
                styliticsWidgetIO.unobserve(el); // Only fire once per card
            });
        },
        {
            root: styliticsWidgetWrapper,
            threshold: MIN_VISIBLE
        }
    );

    // Observe all outfit cards on initial load
    // MutationObserver is not required since elements are not added/removed, only classes change
    getAllOutfitCards().forEach(el => styliticsWidgetIO.observe(el));
}
/**
 * Observes the Stylitics settings container for the Stylitics script load event and dispatches queued events.
 */
function observeStyliticsScript() {
    const { isStyliticsScriptLoaded } = styliticsSettingsContainer?.dataset || {};
    if (isStyliticsScriptLoaded === 'true') return; // already loaded
    window.console.log('Stylitics: PDP widget loaded - waiting for Stylitics script to load');
    // create a mutation observer to send dispatchevent when the stylitics script is loaded
    const observer = new MutationObserver(() => {
        const { isStyliticsScriptLoaded } = styliticsSettingsContainer?.dataset || {};
        if (isStyliticsScriptLoaded !== 'true' || dispatchEventsToSent.length === 0) return;
        dispatchEventsToSent.forEach(event => {
            // slight delay to ensure Stylitics script is fully initialized and
            setTimeout(() => { styliticsPDPWidgetContainer.dispatchEvent(event); }, 100);
        });
        dispatchEventsToSent.slice(0); // delete events after dispatching
        observer.disconnect(); // Stop observing after the event is dispatched
    });

    observer.observe(styliticsSettingsContainer, { attributes: true, attributeFilter: ['data-is-stylitics-script-loaded'] });
}
/**
 * Fetches Stylitics bundles data for a given URL.
 * @param {string} styliticsUrl - The URL to fetch Stylitics data from.
 * @param {string} productId - The product ID associated with the Stylitics data.
 */
function updateStyliticsWidget(styliticsUrl, productId) {
    if (!styliticsUrl) {
        styliticsPDPWidgetContainer.innerHTML = '';
        return;
    }
    const $spinner = $(styliticsPDPWidgetContainer).spinner();

    $spinner.start();

    fetch(styliticsUrl, { method: 'GET' })
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(data => {
            styliticsPDPWidgetContainer.innerHTML = '';
            // Not JSON, treat as HTML
            if (data) {
                try {
                    const json = JSON.parse(data);
                    if (json && json.error) {
                        return;
                    }
                } catch (error) {
                    // Not JSON, treat as HTML
                }
                styliticsPDPWidgetContainer.appendChild(renderFragment(data));
                // init swiper carousel
                const carouselEl = queryFirst('.js-swiper', styliticsPDPWidgetContainer);
                if (carouselEl) {
                    initCarouselElement(carouselEl);
                }
            }
            // init swiper carousel
            const carouselEl = queryFirst('.js-swiper', styliticsPDPWidgetContainer);
            if (carouselEl) {
                initCarouselElement(carouselEl);
            }
            $spinner.stop();
            styliticsPDPWidgetContainer.dataset.styliticsRequestedId = productId;
            styliticsPDPWidgetContainer.dataset.styliticsUrl = styliticsUrl;

            const { isStyliticsScriptLoaded } = styliticsSettingsContainer?.dataset || {};
            if (isStyliticsScriptLoaded === 'true') {
                styliticsPDPWidgetContainer.dispatchEvent(new CustomEvent('stylitics:pdp:widget:loaded', { bubbles: true }));
            } else if (styliticsSettingsContainer) {
                window.console.log('Stylitics: PDP widget loaded - Stylitics script not yet loaded, queuing event');
                // Stylitics script is not yet loaded, queue the event to be sent later
                dispatchEventsToSent.push(new CustomEvent('stylitics:pdp:widget:loaded', { bubbles: true }));
                // Start observing the Stylitics script load event
                observeStyliticsScript();
            }
            // Call after rendering the PDP widget (when DOM cards are already present)
            initOutfitImpressions();
        })
        .catch(() => {
            // Clear widget content in case of error in the response
            styliticsPDPWidgetContainer.innerHTML = '';
        })
        .finally(() => {
            $spinner.stop();
        });
}
/**
 * Updates the Stylitics sheet in the quick view modal.
 * @param {*} styliticsButton - The button element that triggered the update.
 */
function updateStyliticsSheet(styliticsButton) {
    const parseBody = html => {
        const $html = $('<div>').append($.parseHTML(html));
        const body = $html.find(bundleSelector)[0];
        return body;
    };
    const quickViewModal = queryFirst(dialogSelector);
    const $quickViewModal = $(`${dialogSelector} ${lookSelector}`);
    const $spinner = $quickViewModal.spinner();
    const { index: tabToOpen } = styliticsButton.dataset;

    $spinner.start();
    fetch(styliticsButton.dataset.url, { method: 'GET' })
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(response => {
            const parsedBody = parseBody(response);
            const modalBody = queryFirst(lookSelector, quickViewModal);

            modalBody.replaceChild(parsedBody, modalBody.firstChild);

            $(`.js-tab-controls button[data-index="${tabToOpen}"`).click();

            // init product tiles in the modal
            document.body.dispatchEvent(new CustomEvent('stylitics:bundle:tile:show', { detail: [modalBody] }));

            // in progress
            requestAnimationFrame(() => scrollSheetTop($(modalBody).closest('.sheet')));

            document.body.dispatchEvent(new CustomEvent('modalContentLoaded'));
            $spinner.stop();
        })
        .catch(() => {
            $spinner.stop();
        });
}

/**
 * Shows the Stylitics PDP widget.
 * @returns {void}
 */
function initializeStyliticsPDPWidget() {
    if (!styliticsPDPWidgetContainer) return;
    const { styliticsUrl, styliticsRequestedId } = styliticsPDPWidgetContainer.dataset;
    if (!styliticsUrl) return;
    const $styliticsPDPWidgetContainer = $(styliticsPDPWidgetContainer);

    updateStyliticsWidget(styliticsUrl, styliticsRequestedId);

    // Update widget when swatch is changed
    $body.on('swatchChangeEvent', (event, el) => {
        if (!el) return;
        const isColorSwatch = el.closest('.js-color-attribute');
        if (!isColorSwatch) return;

        const { styliticsUrl, productId } = isColorSwatch.dataset;
        updateStyliticsWidget(styliticsUrl, productId);
    });

    $styliticsPDPWidgetContainer.on('click', lookTrigger, function () {
        const styliticsButton = this;
        const bundleWrapper = styliticsButton.closest(bundleWrapperSelector);
        if (!bundleWrapper) return;

        const { styliticsBundleId, styliticsBundleIndex, requestedProductId } = bundleWrapper.dataset;
        const styliticsSheetBundle = queryFirst(`${dialogSelector} ${bundleSelector}`);

        // If the same bundle is already loaded, just open the correct tab
        if (styliticsSheetBundle?.dataset?.styliticsBundleId === styliticsBundleId) {
            const { index: tabToOpen } = styliticsButton.dataset;
            const $activeTab = $(`.js-tab-controls button[data-index="${tabToOpen}"`);

            activateTab($activeTab);

            document.body.dispatchEvent(new CustomEvent('modalContentLoaded'));
        } else {
            // Fetch and update the sheet with the new bundle
            updateStyliticsSheet(styliticsButton);
        }
        // send the stylitics analytics event for outfit click immediately, without waiting
        // Fire the analytics event asynchronously, without blocking execution
        styliticsPDPWidgetContainer.dispatchEvent(
            new CustomEvent('stylitics:completeLook:trackClickOutfit', {
                detail: {
                    outfitId: styliticsBundleId,
                    pid: requestedProductId,
                    index: styliticsBundleIndex
                },
                bubbles: true
            })
        );
    });

    $body.on('click', `${dialogSelector} ${swatchSelector}`, e => {
        const $sheet = $(e.currentTarget).closest('.sheet');
        requestAnimationFrame(() => scrollSheetTop($sheet));
    });

    styliticsPDPWidgetContainer.addEventListener('tabActivated', e => {
        if (!e?.detail?.tabActive?.dataset || !e.target) return;
        const { styliticsProductId, styliticsProductItemid, styliticsProductIndex } = e.detail.tabActive.dataset;
        const completeLookContainer = e.target.closest('.js-complete-look-container');
        const { styliticsOutfitid } = completeLookContainer && completeLookContainer.dataset ? completeLookContainer.dataset : {};
        styliticsPDPWidgetContainer.dispatchEvent(
            new CustomEvent('stylitics:completeLook:trackItemView', {
                detail: {
                    pid: styliticsProductId,
                    itemId: styliticsProductItemid,
                    index: styliticsProductIndex,
                    outfitId: styliticsOutfitid
                },
                bubbles: true
            })
        );
    });
}

const isStyliticsPDPAPIWidgetEnabled = !!queryFirst('#isStyliticsPDPAPIWidgetEnabled');
if (isStyliticsPDPAPIWidgetEnabled) {
    initializeStyliticsPDPWidget();
}
